import ColorSelect from 'components/interaction/ColorSelect/index.jsx';
import AddImage from 'components/interaction/AddFiles/AddImage/index.jsx';
import messages from '../messages.js';

const schema = {
  id: 'edit-group',
  properties: [
    {
      id: 'name',
      type: 'text',
      label: messages.name,
      attributes: { maxLength: 250 },
      required: true,
    },
    {
      id: 'color',
      as: ColorSelect,
      label: messages.groupColor,
      required: true,
    },
    {
      id: 'logo',
      as: AddImage,
      label: messages.logo,
      attributes: { crop: 'group' },
    },
    {
      id: 'tagLine',
      type: 'textarea',
      label: messages.tagLine,
      attributes: { rows: 2, maxLength: 250 },
    },
  ],
};

export default schema;
